var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'magazine-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      searchCallbackFlag: false,
      savingFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    magazines () {
      return this.$store.getters.magazineList
    },
    nextPage () {
      return this.$store.getters.magazineListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.magazineListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {}
      this.$store.dispatch('MAGAZINE_LIST_SEARCH', {url: url, data:data, callback: callback})
    },
    goMagazineNew: function () {
      this.$router.push({ path: '/magazines/new' })
    },
    goMagazinePdf: function(path) {
      return path + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
    },
    goMagazineEdit: function(magazineId) {
      this.$router.push({ path: '/magazines/' + magazineId + '/edit'})
    },
    magazineDelete: function(magazineId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.savingFlag = true
        this.$store.dispatch('MAGAZINE_DELETE', {id: magazineId, callback: this.onSaved})
      }
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/magazines')
    },
    onClickImageModalShow: function (magazine) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = magazine.attributes['magazine-picture-path'] + '?token=' + this.authToken + '&timestamp=' + self.timeStamp
      text.textContent = magazine.attributes['magazine-title']
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/magazine-list.js